module.exports = __webpack_public_path__ + "img/ETH.e1941637.png";